module.exports = __webpack_public_path__ + "static/media/icon-supplies-bedikacloths.39fb6a0a.svg";